import {
  createRef,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./Container.css";
import BgFragment from "./BgFragment";
import { getRandomFragment, patterns } from "./helpers/fragments";

import { fragments_config, phone_fragments_config } from "./config/settings";

function Container2D({ pattern, children, options }) {
  const [populatedPages, setPopulatedPages] = useState(0);
  const [fragments, setFragments] = useState([]);
  const [populated, setPopulated] = useState(false);
  const [fragmentsConfig, setFragmentsConfig] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (!fragmentsConfig) {
      if (window?.innerWidth < 700) {
        setFragmentsConfig({
          ...fragments_config,
          ...phone_fragments_config,
        });
      } else {
        setFragmentsConfig({
          ...fragments_config,
        });
      }
      return;
    }
    const color = options.color || fragmentsConfig.COLOR;
    for (let i = 0; i < fragmentsConfig.ROWS * fragmentsConfig.COLUMNS; i++) {
      const ref = createRef();
      fragments.push([
        <BgFragment
          icon={getRandomFragment(fragmentsConfig.ICON_SIZE, color)}
          posX={-100}
          posY={-100}
          ref={ref}
          color={color}
        />,
        ref,
      ]);
    }
    setPopulated(true);
    setTimeout(() => deployFragments(), 10);
    const interval = setInterval(() => deployFragments(), 2000);
    return () => clearInterval(interval);
  }, [fragmentsConfig, ref]);

  useEffect(() => {
    populated && deployFragments(pattern);
  }, [pattern, ref]);

  const deployFragments = useCallback(() => {
    if (!fragmentsConfig) return;
    let { COLUMNS, ROWS, ICON_SIZE, COLOR } = fragmentsConfig;
    ROWS = options.rows || ROWS;
    COLUMNS = options.cols || COLUMNS;

    const viewportWidth = ref.current.getBoundingClientRect().width;
    const viewportHeight = ref.current.getBoundingClientRect().height;
    const block_width = viewportWidth / COLUMNS;
    const block_height = viewportHeight / ROWS;

    let deployment_func;

    if (pattern in patterns) {
      deployment_func = patterns[pattern];
      deployment_func({
        fragments,
        block_width,
        block_height,
        ROWS,
        COLUMNS,
        options,
      });
    } else {
      deployment_func = patterns.text;
      deployment_func({
        fragments,
        block_width,
        block_height,
        ROWS,
        COLUMNS,
        text: pattern,
        options,
      });
    }
  }, [fragmentsConfig]);
  return (
    <div className="Container2d" ref={ref}>
      {children}
      <div className="container">{fragments.map((el) => el[0])}</div>
    </div>
  );
}

export default Container2D;
